var DeviceFields;

(function (DeviceFields) {
  DeviceFields["DEVICE_ID"] = "deviceId";
  DeviceFields["APP_ID"] = "appId";
  DeviceFields["APP_VERSION"] = "appVersion";
  DeviceFields["PLATFORM"] = "platform";
  DeviceFields["PLATFORM_VERSION"] = "platformVersion";
  DeviceFields["SDK_VERSION"] = "sdkVersion";
})(DeviceFields || (DeviceFields = {}));

export default DeviceFields;